export enum AccountKind {
  CORPORATE = 'CORPORATE',
  PRIVATE = 'PRIVATE',
}
export enum AccountStatus {
  ACTIVE = 'ACTIVE',
  BLOCKED = 'BLOCKED',
  REVIEWING = 'REVIEWING',
}

const AVAILABLE_ACCOUNT_KIND = Object.keys(AccountKind);
const AVAILABLE_ACCOUNT_STATUS = Object.keys(AccountStatus);

class Account {
  public readonly id: string;
  public readonly companyName: string;
  public readonly representativeName: string;
  public readonly companyUrl: string;
  public readonly departmentName: string;
  public readonly tel: string;
  public readonly kind: AccountKind;
  public readonly status: AccountStatus;
  public readonly questionnaireAnswer?: string;
  constructor({
    id,
    companyName,
    representativeName,
    companyUrl,
    departmentName,
    tel,
    kind,
    status,
    questionnaireAnswer,
  }: {
    id: string;
    companyName: string;
    representativeName: string;
    companyUrl: string;
    departmentName: string;
    tel: string;
    kind: AccountKind;
    status: AccountStatus;
    questionnaireAnswer?: string;
  }) {
    this.id = id;
    this.companyName = companyName;
    this.representativeName = representativeName;
    this.companyUrl = companyUrl;
    this.departmentName = departmentName;
    this.tel = tel;
    this.kind = kind;
    this.status = status;
    this.questionnaireAnswer = questionnaireAnswer;
  }

  public static fromJSON = (value: any) => {
    const {
      id,
      companyName,
      representativeName,
      companyUrl,
      departmentName,
      tel,
      kind,
      status,
      questionnaireAnswer,
    } = Object.assign({}, value);

    if (typeof id !== 'string') throw new TypeError('.id must be a string');
    if (typeof companyName !== 'string') throw new TypeError('.companyName must be a string');
    if (typeof representativeName !== 'string') throw new TypeError('.representativeName must be a string');
    if (!!companyUrl && typeof companyUrl !== 'string') throw new TypeError('.companyUrl must be a string');
    if (typeof tel !== 'string') throw new TypeError('.tel must be a string');
    if (kind && !AVAILABLE_ACCOUNT_KIND.includes(kind)) throw new TypeError('.kind must be a valid action string');
    if (status && !AVAILABLE_ACCOUNT_STATUS.includes(status)) throw new TypeError('.status must be a valid string');

    return new Account({
      id,
      companyName,
      representativeName,
      companyUrl: companyUrl || '',
      departmentName: departmentName || '',
      tel,
      kind,
      status,
      questionnaireAnswer: questionnaireAnswer || '',
    });
  };
}

export default Account;
